// extracted by mini-css-extract-plugin
module.exports = {"contentVideo":"ContentVideo_contentVideo__9ugKJ","video":"ContentVideo_video__3e6Po"};